module.exports = __webpack_public_path__ + "6bac1d335cbc3800c3e4e4c37d42c788.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/torque-webfont/torque-light.ttf
// module id = 97
// module chunks = 0